import FlipNumbers from './flipnumbers';
import FlipNumber from './flipnumber';

export default FlipNumbers;

export { FlipNumber };